module.exports = __webpack_public_path__ + "img/d79954b.jpeg";